import styled from 'styled-components';

//prettier-ignore
export const Tile = styled.button<{ selected?: boolean }>`
  background: ${({ theme }) => theme.background.default};
  border: none;

  ${({ theme }) =>
    theme.innerAlignBorder(theme.border.xs, theme.border.weak)}

  border-radius: ${({ theme }) => theme.borderRadius.md};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.xl} ${({ theme }) => theme.spacing['2Xl']};

  width: 103px;
  height: 112px;



  &:not(:disabled):hover {
    cursor: pointer;

    ${({ theme }) =>
      theme.innerAlignBorder(theme.border.sm, theme.border.default)}
  }

  &:not(:disabled):active,
  &.selected {
    ${({ theme }) =>
      theme.innerAlignBorder(theme.border.xs, theme.border.strong)}
  }
`;

export const Icon = styled.div`
  color: ${({ theme }) => theme.brand.primary};
  font-size: ${({ theme }) => theme.spacing['6Xl']};
  height: ${({ theme }) => theme.spacing['6Xl']};
`;

export const Label = styled.div`
  text-transform: capitalize;
`;
